import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DEFAULT_TIERED_PRICE_CONFIG_CONTEXT_VALUE = {
  effectiveCurrencyCode: undefined,
  readOnly: false
};
export const TieredPriceConfigContext = /*#__PURE__*/createContext(DEFAULT_TIERED_PRICE_CONFIG_CONTEXT_VALUE);
export const useTieredPriceConfigContext = () => {
  return useContext(TieredPriceConfigContext);
};
export const TieredPriceContextProvider = ({
  children,
  effectiveCurrencyCode,
  readOnly = false
}) => {
  const TIERED_PRICE_CONFIG_CONTEXT_VALUE = useMemo(() => {
    return Object.assign({}, DEFAULT_TIERED_PRICE_CONFIG_CONTEXT_VALUE, {
      effectiveCurrencyCode,
      readOnly
    });
  }, [effectiveCurrencyCode, readOnly]);
  return /*#__PURE__*/_jsx(TieredPriceConfigContext.Provider, {
    value: TIERED_PRICE_CONFIG_CONTEXT_VALUE,
    children: children
  });
};